import id from './id.js';
import initialState from './initial-state.js';
import selectorDefinitions from './selectors/index.js';
const exchangeReduxDefinition = {
    id,
    type: 'redux-module',
    initialState,
    eventReducers: {
        exchangeableAssets: (state, payload) => {
            const nextState = {
                ...state,
                exchangeableAssets: payload,
            };
            return nextState;
        },
        exchangeStatus: (state, payload) => ({
            ...state,
            status: payload,
        }),
        exchangeAvailability: (state, payload) => ({
            ...state,
            availability: payload,
        }),
    },
    selectorDefinitions,
};
export default exchangeReduxDefinition;
